import { render, staticRenderFns } from "./StoreAdd.vue?vue&type=template&id=08619dde&"
import script from "./StoreAdd.vue?vue&type=script&lang=js&"
export * from "./StoreAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports